module.exports = __webpack_public_path__ + "static/media/Michelle F.b6376c1f.png";